// Un numero de caso ("#20260218620051") que abre el caso. Se usa en el asistente, en la conversacion y en los casos
// unidos.
import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { buscarCasos } from '../api/casos';
import { toast } from './toasts';

export function EnlaceCaso({ numero, children }: { numero: string; children?: ReactNode }) {
  const ir = useNavigate();
  const abrir = async () => {
    const c = (await buscarCasos(numero)).find((x) => String(x.numero) === numero);
    if (c) ir(`/bandeja/casos?caso=${c.id}`);
    else toast(`No encontré el caso #${numero}.`, 'error');
  };
  return (
    <button type="button" className="linkish caso-n" onClick={() => void abrir()}>
      {children ?? `#${numero}`}
    </button>
  );
}
